var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex mb-3"},[_c('label',{staticClass:"mr-auto",attrs:{"for":""}},[_vm._v("Duration")]),_c('v-select',{staticClass:"w-1/2",attrs:{"options":_vm.durations,"placeholder":"Select Duration"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }